import ActualAdvanceSettingDTO from 'features/requirements/dtos/ActualAdvanceSettingDTO';
import { convertCodeToLabel } from 'features/shared/helpers/currencyHelper';
import { formatPrice } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './advanceRow.module.scss';

interface Props {
  advanceSetting: ActualAdvanceSettingDTO;
  bindField: any;
  error?: string;
}

const AdvanceRow = ({ advanceSetting, bindField, error }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // helpers
  const getMaturity = (): string => {
    if (advanceSetting.month) {
      return `${advanceSetting.day}.${advanceSetting.month}.`;
    } else {
      return `${advanceSetting.day}. ${tLabels("advanceRow.dayOfMonth")}`;
    }   
  }

  const getAmount = (): string => {
    let amount = advanceSetting.amount ?? 0;
    return formatPrice(amount, advanceSetting.currency!, 2);  
  }

  // sub-render
  const renderError = () => {
    if (error) {
      return (
        <div className="d-block invalid-feedback text-right">
          {error}
        </div>
      );
    }
  }

  // render
  return (
    <>
      <div className="row align-items-center no-gutters">
        <div className="col-sm-4 col-lg mb-1 mb-sm-0">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("advanceRow.maturity")}
            </div>
            <div>
              {getMaturity()}
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-lg mb-1 mb-sm-0">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("advanceRow.currentAmount")}
            </div>
            <div>
              {getAmount()}
            </div>
          </div>
        </div>
        <div className={`col-sm-4 col-lg-auto ${styles.amountInputCol}`}>
          <div className="d-flex d-sm-block justify-content-between align-items-center">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("advanceRow.requestedAmount")}
            </div>
            <div>
              <div className={`input-group ${styles.amountInputGroup}`}>
                <input 
                  className={`form-control${error ? " border-danger" : ""}`}
                  {...bindField(`DESC_TMzalohyNovaVyse${advanceSetting.orderOfDueDate}`)}
                />
                <div className="input-group-append">
                  <span className="input-group-text">{convertCodeToLabel(advanceSetting.currency!)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderError()}
    </>
  )
}

export default AdvanceRow;
